import React from "react";
import MediaControls from "../../features/MediaControls";
import ConferencePanel from "../../features/Conference/ConferencePanel";
export default function FooterContainer() {
    return (
         <div style={{
            fontFamily: 'monospace',
            padding: '1rem',
            maxWidth: '50rem',
            margin: '0 auto'
        }}>
        <MediaControls />
        <ConferencePanel />
        </div>
    );
}
